import joinURL from '../common/joinURL.js'

export default function resourcePrefetch({XMLHttpRequest, Promise, santaBase},
  {siteModel, publicModel, pageInfo, shouldTimeout, wixBiSession, dynamicModel, isServerSide, mobileView, experiment, requirejs}) {
  const cache = {}
  const pending = {}

  function _prefetch(url, options, pageId) {
    const r = new XMLHttpRequest()

    r.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        const cached = options.parse ? options.parse(r.response) : r.response
        cache[url] = cached
        pending[url].filter(op =>
          op.success
        ).forEach(op => {
          op.success(cached)
        })
      } else {
        this.onerror()
      }
    }
    r.onerror = function () {
      cache[url] = r
      pending[url].filter(op =>
        op.error
      ).forEach(op => {
        op.error(r)
      })
    }
    r.onloadend = function () {
      delete pending[url]
    }

    r.open('GET', url, true)

    //Property timeout MUST be after .open() and before .send()
    //This is related to an issue with IE - https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/timeout
    if (shouldTimeout) {
      r.timeout = 2000
      r.ontimeout = function () {
        if (pageId) {
          //beat 2 = 'reset' event
          wixBiSession.beat(2, pageId)
        }
      }
    }
    //Property timeout MUST be after .open() and before .send()

    if (options.accept) {
      r.setRequestHeader('Accept', options.accept)
    }

    r.send()
  }

  function prefetch(url, options, pageId) {
    if (url) {
      options = options || {}
      const cached = cache[url]
      if (cached) {
        if (options.success) {
          options.success(cached)
        }
      } else {
        let p = pending[url]
        if (!p) {
          pending[url] = p = []
          _prefetch(url, options, pageId)
        }
        p.push(options)
      }
    }
  }

  function prefetchJSON(url, pageId) {
    prefetch(url, {
      accept: 'application/json',
      parse(response) {
        let json = null
        try {
          json = JSON.parse(response)
          if (wixBiSession.et < 6) {
            prefetchComps(json)
            prefetchSvg(json.structure, response)
          }
        } catch (e) {
          // empty
        }
        return json
      }
    }, pageId)
  }

  let pc = null
  function prefetchComps(json) {
    if (Promise && json.structure && experiment.isOpen('prefetchComps')) {
      if (pc === null) {
        pc = new Promise(resolve => {
          requirejs(['coreUtils'], ({prefetchComponents}) => {
            resolve(prefetchComponents)
          })
        })
      }
      pc.then(prefetchComponents => {
        const hasBlog = prefetchComponents(json, siteModel, mobileView)
        if (hasBlog) {
          prefetchJSON(joinURL(santaBase, 'static/wixapps/apps/blog/descriptor.json'))
        }
      })
    }
  }

  function shapeSkinNameToUrl(shapeSkinName) {
    function getSvgUri(version, svgHash, shapeName) {
      return svgHash + (version === 1 ? '_svgshape.v1.' + shapeName : '') + '.svg' //eslint-disable-line prefer-template
    }

    const mediaRootUrl = siteModel.serviceTopology.mediaRootUrl
    const partsArr = shapeSkinName.replace(/^.*\//, '').split('.')
    const version = partsArr[1] === 'v1' ? 1 : 2
    const svgHash = partsArr[2].replace(/svg_/i, '')
    const svgName = partsArr[3]
    const svgUri = getSvgUri(version, svgHash, svgName)
    return joinURL(mediaRootUrl, 'shapes', svgUri)
  }

  const svgMap = {
    'skins.viewer.svgshape.SvgShapeDefaultSki': true
  }

  function prefetchSvg(structure, response) {
    if (structure && response.indexOf('"svg') !== -1) {
      const svgs = JSON.stringify(structure).match(/"skin"\s*:\s*"svg[^"]+"/g)
      if (svgs) {
        svgs
          .map(m => {
            m = m.match(/svg[^"]+/)
            return m && m[0]
          })
          .filter(svg => {
            if (!svg || svgMap[svg]) {
              return false
            }
            svgMap[svg] = true
            return true
          })
          .map(shapeSkinNameToUrl)
          .forEach(url => {
            prefetch(url)
          })
      }
    }
  }

  function getFirstUrl(pageJsonFileName) {
    if (pageJsonFileName) {
      const topology = publicModel.pageList.topology[0]
      return topology.baseUrl + topology.parts.replace('{filename}', pageJsonFileName)
    }
  }

  function getMasterPageFirstURL() {
    const {pageList: {masterPageJsonFileName, masterPage}} = publicModel
    return getFirstUrl(masterPageJsonFileName) || masterPage && masterPage[0]
  }

  function getPageFirstURL() {
    return getFirstUrl(pageInfo.pageJsonFileName) || pageInfo.urls[0]
  }

  function shouldPrefetchPagesJsons() {
    return !isServerSide
  }

  try {
    prefetchJSON(dynamicModel)

    if (shouldPrefetchPagesJsons()) {
      prefetchJSON(getMasterPageFirstURL(), 'masterPage')
      if (pageInfo) {
        prefetchJSON(getPageFirstURL(), pageInfo.pageId)
      }
    }
  } catch (e) {
    // empty
  }

  let cbs = []

  function async(cb) {
    if (cbs.push(cb) === 1) {
      setTimeout(() => {
        const fs = cbs
        cbs = []
        fs.forEach(f => {
          f()
        })
      }, 0)
    }
  }

  return function (options) {
    const url = options.url
    const cached = cache[url]
    if (cached) {
      async(() => {
        if (cached instanceof XMLHttpRequest) {
          options.error(cached)
        } else {
          options.success(cached)
        }
      })
    } else if (pending[url]) {
      pending[url].push(options)
    } else {
      return false
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/viewer/resourcePrefetch.js